import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./Configs/AuthConfigs";

const msalInstance = new PublicClientApplication(msalConfig);

// ** Create a wrapper component to ensure MSAL is initialized before rendering the app **
const MsalAppProvider: React.FC = () => {
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    console.log("Window Origin:", window.origin);
    console.log("Redirect URI in MSAL Config:", msalInstance.getConfiguration().auth.redirectUri);

    msalInstance.initialize().then(() => {
      console.log("MSAL initialized");
      setIsInitialized(true);
      return msalInstance.handleRedirectPromise();
    }).then((response) => {
      if (response) {
        console.log("User authenticated:", response);
      } else {
        console.log("No response from handleRedirectPromise. Checking existing accounts...");
        const accounts = msalInstance.getAllAccounts();
        if (accounts.length > 0) {
          console.log("User is already logged in:", accounts[0]);
        } else {
          console.warn("No active user session.");
        }
      }
    }).catch(error => {
      console.error("MSAL authentication error:", error);
    });
  });


  
  // Show a loading screen until MSAL is initialized
  if (!isInitialized) {
    return <div>Loading authentication...</div>;
  }

  return (
    <MsalProvider instance={msalInstance}>
      <App />
    </MsalProvider>
  );
};

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <React.StrictMode>
    <MsalAppProvider />
  </React.StrictMode>
);

reportWebVitals();
